import { frontendURL } from '../../../helper/URLHelper';
import KanbanIndex from './Index.vue';
import KanbanBoardView from './BoardView.vue';
import KanbanBoardSettings from './BoardSettingsPage.vue';

const meta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    component: KanbanIndex,
    name: 'kanban_view',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/kanban/boards/:boardId'),
    component: KanbanBoardView,
    name: 'kanban_board',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/kanban/boards/:boardId/settings'),
    component: KanbanBoardSettings,
    name: 'kanban_board_settings',
    meta,
  },
];
